import { formatInTimeZone } from "date-fns-tz";

export function formatDate(
  timestamp: number,
  pattern: string,
  timezoneIdentifier: string,
) {
  return formatInTimeZone(timestamp, timezoneIdentifier, pattern);
}
